import { Alert } from "reactstrap";
import { InfoIcon } from "./icons";

const Info = (props: any) => {
    const { color="info", style } = props

    return (
        <Alert color={color} style={{padding: '8px', margin: '5px 0', ...style}}> 
            <div style={{display: 'flex', alignItems: 'center'}}>
                <div style={{flex: '0 0 30px', marginTop: '-2px'}}><InfoIcon color={`var(--bs-${color}-text-emphasis)`}/></div>
                <div style={{flex: '1 1 auto'}}>
                    {props.children}
                </div>
            </div>
        </Alert>
    )
}

export default Info;